var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSaving)?_c('svg',{staticClass:"svg-loader"},[_c('use',{attrs:{"xlink:href":require('@/assets/img/icons/loader.svg') +
            '#layer'}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }